
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQRFofFSw2_1fKKHV112_AoR7MC6VAWuObQ7KwqttyMYMeta } from "/app/build/projects/Kredo/pages/index.vue?macro=true";
import { default as signinOo2derCyTuqymnPb0AQBTGvD8gSr37me8OTIL_45UvQfwMeta } from "/app/build/projects/Kredo/pages/auth/signin.vue?macro=true";
import { default as signinoavg0JrVDh50IYa27_tLFstM6U3mSvVI_45REyPljK14QMeta } from "/app/build/projects/Kredo/pages/admin/auth/signin.vue?macro=true";
export default [
  {
    name: "index___uk",
    path: "/",
    component: () => import("/app/build/projects/Kredo/pages/index.vue")
  },
  {
    name: "auth-signin___uk",
    path: "/auth/signin",
    component: () => import("/app/build/projects/Kredo/pages/auth/signin.vue")
  },
  {
    name: "admin-auth-signin___uk",
    path: "/admin/auth/signin",
    component: () => import("/app/build/projects/Kredo/pages/admin/auth/signin.vue")
  }
]